// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCreditCardOutlinedSvg from "@fishx/icons-svg/es/asn/PCreditCardOutlined";
import FishxIcon from '../components/FishxIcon';

var PCreditCardOutlined = function PCreditCardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCreditCardOutlinedSvg
  }));
};

PCreditCardOutlined.displayName = 'PCreditCardOutlined';
export default React.forwardRef(PCreditCardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCreditCardOutlined.js
// module id = 3316
// module chunks = 0